import React, { useState, useCallback } from "react";
import * as styles from "./FaqItem.module.scss";

import arrowDown from "../../../images/arrow-down.svg";

const FaqItem = ({faqData = []}) => {
  const [openQuestions, setOpenQuestions] = useState([]);

  const toggleAnswer = (index) => {
    setOpenQuestions((prevOpenQuestions) =>
      prevOpenQuestions.includes(index)
        ? prevOpenQuestions.filter((i) => i !== index)
        : [...prevOpenQuestions, index]
    );
  };

  const handleKeyDown = useCallback((e, index) => {
    if (e.key === "Enter" || e.key === " ") {
      toggleAnswer(index);
    }
  }, []);

  return (
    <>
      <div className={styles.faqContainer}>
        {faqData.map((faq, index) => (
          <div
            key={faq.title}
            className={`${styles.faqItem} ${
              openQuestions.includes(index) ? styles.faqOpen : ""
            }`}
          >
            <div
              className={styles.faqQuestion}
              onClick={() => toggleAnswer(index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              role="button"
              tabIndex="0"
            >
              <span>{faq.title}</span>
              <img
                className={styles.faqArrow}
                src={arrowDown}
                alt="Arrow icon"
              />
            </div>
            <div
              className={`${styles.faqAnswer} ${
                openQuestions.includes(index) ? styles.visible : styles.hidden
              }`}
            >
              <p>{faq.description}</p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default FaqItem;
